import { Component, Input, OnInit } from '@angular/core';
import { PatientsService } from '../../../_services/patients/patients.service';
import { SessionService } from '../../../_services/session/session.service';
import { BaseComponent } from '../../base/base.component';
import moment from 'moment';
import IPatientHasTreatment from '../../../_interfaces/IPatientHasTreatment';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import ITreatment from '../../../_interfaces/ITreatment';

@Component({
  standalone: true,
  selector: 'app-selector-patient-treatment',
  templateUrl: './selector-patient-treatment.component.html',
  styleUrls: ['./selector-patient-treatment.component.scss'],
  imports: [SelectModule, FormsModule, TranslatePipe],
})
export class SelectorPatientTreatmentComponent
  extends BaseComponent
  implements OnInit
{
  @Input('patients_id') public patients_id: number;
  @Input('placeholder') public placeholder: string;
  @Input('onSelect') public onSelect: (IProduct) => void = () => undefined;
  public treatments: IPatientHasTreatment[];
  @Input('selected')
  public selected: IPatientHasTreatment | ITreatment;

  constructor(
    public patientsService: PatientsService,
    public session: SessionService
  ) {
    super(session);
  }

  public clear() {
    this.selected = undefined;
    this.onSelect(this.selected);
  }

  public display(treatment: IPatientHasTreatment) {
    let appointment = '';
    if (treatment.appointment) {
      const date = moment(treatment.appointment.start).format(
        'DD/MM/YYYY HH:mm'
      );
      appointment = `(${date}: ${treatment.appointment.name})`;
    }

    return `${treatment.treatment.name} ${appointment}`;
  }

  public loadPatientTreatments() {
    const siteId = +this.sites_id || undefined;
    this.patientsService
      .getTreatments(this.customers_id, this.patients_id, siteId)
      .subscribe((treatments) => {
        this.treatments = treatments.map((treatment) => {
          return {
            ...treatment,
            name: this.display(treatment),
          };
        });
        if (this.selected) {
          this.selected = this.treatments.find(
            (treatment) => treatment.id === this.selected.id
          );
          this.onSelect(this.selected);
        }
      });
  }

  public ngOnInit(): void {
    super.ngOnInit();
    this.loadPatientTreatments();
  }
}
